export enum PaymentMethod {
  None = 0,
  Cash = 1,
  Check = 2,
  CreditCard = 3,
  GiftCard = 4,
  VaultedCard = 5,
  WorldPay = 6,
  Institutional = 7,
  TotusGiftCard = 8,
  AmusementConnectGiftCard = 9,
  BankAccount,
}
